export default class Answer {
  readonly id: number
  readonly userId: number
  readonly body: string
  readonly qId: number
  readonly correct: boolean
  readonly answerItemId: number
  readonly userExamId: number
  readonly marked: boolean
  readonly createdAt: string
  readonly updatedAt: string

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.userId = data.userId
    this.body = data.body
    this.qId = data.qId
    this.correct = data.correct
    this.answerItemId = data.answerItemId
    this.userExamId = data.userExamId
    this.marked = data.marked
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
  }
}
